import { render, staticRenderFns } from "./ListContainerWidget.vue?vue&type=template&id=60798b7f&scoped=true"
import script from "./ListContainerWidget.vue?vue&type=script&lang=js"
export * from "./ListContainerWidget.vue?vue&type=script&lang=js"
import style0 from "./ListContainerWidget.vue?vue&type=style&index=0&id=60798b7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60798b7f",
  null
  
)

export default component.exports